import { render, staticRenderFns } from "./ProjectInvoice.vue?vue&type=template&id=5e84650e&scoped=true"
import script from "./ProjectInvoice.vue?vue&type=script&lang=js"
export * from "./ProjectInvoice.vue?vue&type=script&lang=js"
import style0 from "./ProjectInvoice.vue?vue&type=style&index=0&id=5e84650e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e84650e",
  null
  
)

export default component.exports